/* Treasure Vault — in-stock-only collection browsing.

   Collections list only products a shopper can buy or pre-order. Filtering runs
   server-side through Shopify's native availability filter (filter.v.availability=1),
   so product counts and pagination are exact and a restocked product reappears
   automatically. Sold-out products stay published: direct product URLs, the sitemap
   and structured data are unaffected.

   1. Internal links to a collection gain the filter at click time. Crawlers still
      see clean collection URLs, which remain the canonical URLs.
   2. A shopper who lands on a clean collection URL (search engine, ad, typed link)
      is already shown only available cards by Liquid; the exact filtered grid, count,
      filters and pagination are then swapped in from the Section Rendering API and the
      address bar is updated without a reload. */
(function(){
  'use strict';
  var PARAM = 'filter.v.availability';
  var COLLECTION_PATH = /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/collections\/(?!vendors\/?$|types\/?$)[^\/]+\/?$/i;

  function addAvailability(link){
    if(!link || !link.getAttribute('href')) return;
    var url;
    try { url = new URL(link.href, window.location.href); } catch(e){ return; }
    if(url.origin !== window.location.origin || !COLLECTION_PATH.test(url.pathname) || url.searchParams.has(PARAM)) return;
    url.searchParams.set(PARAM, '1');
    link.setAttribute('href', url.pathname + url.search + url.hash);
  }

  function onActivate(e){
    var link = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if(link) addAvailability(link);
  }
  document.addEventListener('click', onActivate, true);
  document.addEventListener('auxclick', onActivate, true);

  function syncCollection(){
    var host = document.querySelector('[data-availability-sync]');
    if(!host) return;
    var target = host.getAttribute('data-availability-sync');
    var sectionId = host.getAttribute('data-section-id');
    var finish = function(){ host.removeAttribute('data-availability-sync'); host.removeAttribute('aria-busy'); };
    if(!target || !sectionId || !window.fetch || !window.DOMParser){ finish(); return; }

    var url;
    try {
      url = new URL(target, window.location.href);
      url.searchParams.delete('page');
      url.searchParams.set(PARAM, '1');
    } catch(e){ finish(); return; }

    host.setAttribute('aria-busy', 'true');
    var failsafe = setTimeout(finish, 5000);
    var request = new URL(url.href);
    request.searchParams.set('section_id', sectionId);

    fetch(request.pathname + request.search, {credentials: 'same-origin', headers: {'X-Requested-With': 'XMLHttpRequest'}})
      .then(function(r){ if(!r.ok) throw new Error('Section request failed'); return r.text(); })
      .then(function(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-section-type="collection"]');
        /* Only swap when Shopify actually applied the filter. */
        if(!next || next.hasAttribute('data-availability-sync')) throw new Error('Availability filter not applied');

        var swapped = false;
        ['[data-coll-results]', '[data-filter-form]'].forEach(function(sel){
          var current = host.querySelector(sel);
          var fresh = next.querySelector(sel);
          if(current && fresh){ current.innerHTML = fresh.innerHTML; swapped = true; }
        });
        var count = host.querySelector('[data-coll-count]');
        var freshCount = next.querySelector('[data-coll-count]');
        if(count && freshCount) count.textContent = freshCount.textContent;

        if(swapped && window.history && history.replaceState){
          history.replaceState(history.state, '', url.pathname + url.search + window.location.hash);
        }
        document.dispatchEvent(new CustomEvent('collection:availability-synced', {detail: {url: url.href}}));
      })
      .catch(function(){ /* Liquid already hides sold-out cards; keep that render. */ })
      .then(function(){ clearTimeout(failsafe); finish(); });
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncCollection);
  else syncCollection();
})();
